import { useState } from 'react';
import { cn } from '../../utils/format';

/**
 * Imagen con fade-in al cargar.
 * Sin imagen (o si la URL falla) NO se muestra ningún placeholder:
 * queda solo el bloque de fondo neutro, conservando la proporción del layout.
 */
export default function SafeImage({ src, alt, seed, className, imgClassName, ...props }) {
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);

  const empty = !src || errored;

  return (
    <div className={cn('relative overflow-hidden bg-mist-100 dark:bg-ink-soft', className)}>
      {empty ? null : (
        <>
          {!loaded && <div className="absolute inset-0 skeleton" />}
          <img
            src={src}
            alt={alt}
            loading="lazy"
            onLoad={() => setLoaded(true)}
            onError={() => setErrored(true)}
            className={cn(
              'h-full w-full object-cover transition-all duration-700 ease-smooth',
              loaded ? 'opacity-100 scale-100' : 'opacity-0 scale-105',
              imgClassName
            )}
            {...props}
          />
        </>
      )}
    </div>
  );
}
